import { FormControl, Select, styled } from '@mui/material';
import { coreThemeColors } from '@youscience/theme';
import { CoreBox, CoreRadio } from '@youscience/core';

import ActionButton from '@components/ActionButton';

import { propsFilter } from '@utils/propsFilter';

export const sxStyles = {
  sectionTitle: {
    fontSize: '1.125rem',
  },
  editBtnTooltip: {
    maxWidth: '78px',

    '&:hover': {
      cursor: 'pointer',
    },
  },
  disabledEditBtn: {
    borderRadius: '40px',
    fontSize: '0.813rem',

    '& > svg:first-of-type': {
      marginRight: '0.5rem',
    },
  },
};

export const StyledApplication = styled(CoreBox)(() => ({
  display: 'flex',
  flexDirection: 'column',
  gap: '1rem',
}));

export const StyledApplicationSection = styled(CoreBox)(() => ({
  display: 'flex',
  flexDirection: 'column',
  alignItems: 'flex-start',
  gap: '0.5rem',
}));

export const StyledApplicationFormControl = styled(FormControl)(() => ({
  alignSelf: 'stretch',
}));

export const StyledApplicationSelect = styled(Select)(() => ({
  alignSelf: 'stretch',
}));

export const StyledApplicationScore = styled(CoreBox)(() => ({
  display: 'flex',
  alignItems: 'center',
  gap: '0.75rem',
}));

export const StyledApplicationScoreNumber = styled(CoreBox, {
  shouldForwardProp: propsFilter(['isSelected', 'isEdit']),
})<{ isSelected?: boolean; isEdit?: boolean }>(({ isSelected, isEdit }) => ({
  display: 'flex',
  alignItems: 'center',
  justifyContent: 'space-around',
  backgroundColor: isEdit && !isSelected ? coreThemeColors.common.white : coreThemeColors.primary.main,
  border: `1px solid ${coreThemeColors.grey[300]}`,
  borderRadius: '4px',
  color: isEdit && !isSelected ? coreThemeColors.common.black : coreThemeColors.common.white,
  width: '40px !important',
  height: '40px !important',
  padding: 0,

  '&:hover': {
    backgroundColor: !isSelected && isEdit && coreThemeColors.primary.containedHoverBackground,
    color: !isSelected && isEdit && coreThemeColors.common.white,
  },
}));

export const StyledApplicationScoreRadio = styled(CoreRadio)(() => ({
  position: 'absolute',
  opacity: 0,
}));

export const StyledEditButton = styled('div')(() => ({
  display: 'flex',
  alignItems: 'center',
  justifyContent: 'center',
  maxWidth: '78px',
  height: '32px',
  padding: '1rem 0.375rem',
  borderRadius: '40px',
  color: coreThemeColors.secondary.main,
  fontSize: '0.813rem',
  transition: 'background-color 0.5s',

  '& > svg:first-of-type': {
    marginRight: '0.5rem',
    fill: coreThemeColors.secondary.main,
  },

  '&:hover': {
    cursor: 'pointer',
    backgroundColor: coreThemeColors.secondary.outlinedHoverBackground,
  },
}));

export const StyledCancelButton = styled('div')(() => ({
  display: 'flex',
  alignItems: 'center',
  justifyContent: 'center',
  width: '100%',
  height: '32px',
  padding: '0.75rem',
  borderRadius: '40px',
  color: coreThemeColors.secondary.main,
  fontSize: '0.813rem',
  transition: 'background-color 0.5s',

  '&:hover': {
    cursor: 'pointer',
    backgroundColor: coreThemeColors.secondary.outlinedHoverBackground,
  },
}));

export const StyledSaveButton = styled(ActionButton)(() => ({
  width: '100%',
  height: '32px',
  backgroundColor: coreThemeColors.secondary.main,
  borderRadius: '40px',
  fontSize: '0.813rem',
  fontWeight: 500,

  '&:hover': {
    backgroundColor: coreThemeColors.secondary.dark,
  },
}));

export const StyledApplicationButtonGroup = styled(CoreBox)(({ theme }) => ({
  display: 'flex',
  flexDirection: 'row',
  alignItems: 'flex-start',
  gap: '0.5rem',

  [theme.breakpoints.down('md')]: {
    alignSelf: 'stretch',
  },
}));
